/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { useEffect, useRef, useState } from "react";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function MembershipSelector({
	name,
	defaultValue,
	disabled = false,
	handelSelect,
}: {
	name: string;
	defaultValue: string;
	disabled: boolean;
	handelSelect: ChangeEventHandler;
}) {
	return (
		<select name={name} defaultValue={defaultValue} disabled={disabled} onChange={handelSelect}>
			<option value="0"></option>
			<option value="1">DERES</option>
			<option value="2">Sistema B</option>
			<option value="3">Pacto Global</option>
			<option value="4">ACDE</option>
			<option value="5">CEMPRE</option>
		</select>
	);
}

function Table({
	memberships,
	setMemberships,
}: {
	memberships: { id: number; value: string }[];
	setMemberships: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;
}) {
	const [showRowForm, setShowRowForm] = useState(false);
	const [editingRowId, setEditingRowId] = useState(0);
	const [newMemberships, setNewMemberships] = useState({ id: -1, value: "" });

	const toastInstance = useRef<ToastComponent>(null);

	function toastCreated() {
		toastInstance.current.show();
	}

	function handleNewMemberships(event: React.ChangeEvent<HTMLInputElement>) {
		setNewMemberships({ id: Math.floor(Math.random() * 10000), value: event.target.value });
	}

	function handleEditMemberships(event: React.ChangeEvent<HTMLInputElement>) {
		setNewMemberships({ id: editingRowId, value: event.target.value });
	}

	function handleClickShowAddRow() {
		if (showRowForm) {
			setShowRowForm(false);
			setNewMemberships({ id: -1, value: "" });
		} else {
			setShowRowForm(true);
		}
	}

	function handleClickSaveRow() {
		if (newMemberships.value === "") {
			toastCreated();
			//alert("Seleccione una membresía");

			return;
		}

		if (editingRowId === 0) {
			setMemberships([
				...memberships.filter((e) => e.value !== newMemberships.value),
				newMemberships,
			]);
		} else {
			setMemberships([
				...memberships
					.filter((e) => e.value !== newMemberships.value)
					.filter((e) => e.id !== editingRowId),
				newMemberships,
			]);
		}

		setShowRowForm(false);
		setEditingRowId(0);
		setNewMemberships({ id: -1, value: "" });
	}

	function handleClickCancelRow() {
		setShowRowForm(false);
		setEditingRowId(0);
		setNewMemberships({ id: -1, value: "" });
	}

	function handleClickEditRow(category: { id: number; value: string }) {
		setEditingRowId(category.id);
		setNewMemberships(category);
	}

	function handleClickDeleteRow(categoryId: number) {
		setMemberships(memberships.filter((e) => e.id !== categoryId));
	}

	return (
		<>
			<ToastComponent
				ref={toastInstance}
				title="Error!"
				content="Seleccione una membresía"
				cssClass="e-toast-danger"
				icon="e-error toast-icons"
			/>
			<table>
				<thead>
					<tr>
						<th colSpan={3}>
							{memberships.length < 5 && (
								<button
									//className="btn-small"
									type="button"
									disabled={Boolean(editingRowId) || showRowForm}
									onClick={handleClickShowAddRow}
								>
									Agregar Membresía
								</button>
							)}
						</th>
					</tr>
				</thead>
				<tbody>
					{showRowForm && (
						<>
							{/* <tr>
                <th>Membresías</th>
                <th></th>
            </tr> */}
							<tr>
								<td>
									<MembershipSelector
										name="newMemberships"
										defaultValue=""
										disabled={false}
										handelSelect={handleNewMemberships}
									/>
								</td>
								<td className="tdActionButtonsWrapper">
									<div className="actionButtonsWrapper">
										<button className="btn-small" type="button" onClick={handleClickSaveRow}>
											Guardar
										</button>
										<button className="btn-small" type="button" onClick={handleClickCancelRow}>
											Cancelar
										</button>
									</div>
								</td>
							</tr>
						</>
					)}
					{memberships.map((d) => {
						return editingRowId === d.id ? (
							<tr key={d.id}>
								<td>
									<MembershipSelector
										name="newMemberships"
										defaultValue={d.value}
										disabled={false}
										handelSelect={handleEditMemberships}
									/>
								</td>
								<td className="tdActionButtonsWrapper">
									<div className="actionButtonsWrapper">
										<button className="btn-small" type="button" onClick={handleClickSaveRow}>
											Guardar
										</button>
										<button className="btn-small" type="button" onClick={handleClickCancelRow}>
											Cancelar
										</button>
									</div>
								</td>
							</tr>
						) : (
							<tr key={d.id}>
								<td>
									<MembershipSelector
										name={`memberships${d.value}`}
										defaultValue={d.value}
										disabled={true}
									/>
								</td>

								<td className="tdActionButtonsWrapper">
									<div className="actionButtonsWrapper">
										<button
											className="btn-small"
											type="button"
											disabled={Boolean(editingRowId) || showRowForm}
											onClick={() => handleClickEditRow(d)}
										>
											Editar
										</button>
										<button
											className="btn-small"
											type="button"
											disabled={Boolean(editingRowId) || showRowForm}
											onClick={() => handleClickDeleteRow(d.id)}
										>
											Borrar
										</button>
									</div>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</>
	);
}

function CompanyMemberships() {
	const { currentStep, countryBrandApplication, update, formRef, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;
	const { companyMemberships = [], companyMembershipsOthers } = countryBrandApplication;
	const [memberships, setMemberships] = useState([]);

	useEffect(() => {
		setMemberships(
			companyMemberships.map((e) => {
				return { id: Math.floor(Math.random() * 10000), value: e };
			})
		);
	}, []);

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		function submitStepData() {
			const formElement = formRef.current as HTMLFormElement;
			const companyMemberships = memberships.map((e) => {
				return e.value;
			});
			const companyMembershipsOthers = formElement.elements.companyMembershipsOthers.value;
			update({
				data: {
					companyMemberships,
					companyMembershipsOthers,
				},
				nextStep: currentStep + 1,
			});
		}
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, [memberships]);

	return (
		<div className="step-page" id="step-12">
			<section>
				<h3>12 - Membresías de la empresa</h3>
				<Table memberships={memberships} setMemberships={setMemberships} />
				<label htmlFor="companyMembershipsOthers">
					{"Otros (especifique)"}
					<textarea name="companyMembershipsOthers" defaultValue={companyMembershipsOthers} />
				</label>
			</section>
		</div>
	);
}

export { CompanyMemberships };
